<template>
    <div class="indexWrap">
        <div class="indexSection bgcScN2">
            <router-view></router-view>
        </div>
        <div class="indexBottom rowJbAc borderTop borderScN4 bgcScW">
            <div class="colAc" @click="clickNav(1)">
                <div class="navIcon" :class="[selectNav == 1 ? 'icon-message-fill fontMcA1' : 'icon-message1 navText']"></div>
                <!-- <img src="../../assets/static/index/message.svg" alt="" class="imgStyle" v-if="selectNav !=1">
                <img src="../../assets/static/index/message-fill.svg" alt="" class="imgStyle" v-if="selectNav ==1"> -->
                <div class="fontH5 " :class="[selectNav==1? 'fontMcA1' : 'navText']">消息</div>
            </div>
            <div class="colAc" @click="clickNav(2)">
                <div class="navIcon" :class="[selectNav == 2 ? 'icon-function-fill fontMcA1' : 'icon-function navText']"></div>
                <!-- <img src="../../assets/static/index/function.svg" alt="" class="imgStyle" v-if="selectNav !=2">
                <img src="../../assets/static/index/function-fill.svg" alt="" class="imgStyle" v-if="selectNav ==2"> -->
                <div class="fontH5 " :class="[selectNav==2? 'fontMcA1' : 'navText']">服务</div>
            </div>
            <div class="colAc" @click="clickNav(3)">
                <div class="navIcon" :class="[selectNav == 3 ? 'icon-mine-fill fontMcA1' : 'icon-mine navText']"></div>
                 <!-- <img src="../../assets/static/index/mine.svg" alt="" class="imgStyle" v-if="selectNav !=3">
                <img src="../../assets/static/index/mine-fill.svg" alt="" class="imgStyle" v-if="selectNav ==3"> -->
                <div class="fontH5 " :class="[selectNav==3 ? 'fontMcA1' : 'navText']">我的</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            selectNav: ''
        }
    },
    beforeRouteEnter(to,from,next) {
        console.log('进入index:',to,from)
        next(vm => {
            if(to.path == '/index/message') { // 消息
                vm.selectNav = 1
            }else if(to.path == '/index/server') { // 服务
                vm.selectNav = 2
            }else if(to.path == '/index/home') { // 我的
                vm.selectNav = 3
            }
        })
    },
    watch:{
        $route(to,from){
            if(to.path == '/index/message') { // 消息
                this.selectNav = 1
            }else if(to.path == '/index/server') { // 服务
                this.selectNav = 2
            }else if(to.path == '/index/home') { // 我的
                this.selectNav = 3
            }
        }
    },
    methods: {
        clickNav(nav) {
            if(this.selectNav != nav) {
                this.selectNav = nav
                if(nav == 1) {
                    this.$router.push('/index/message')
                }else if(nav == 2) {
                    this.$router.push('/index/server')
                }else if(nav == 3) {
                    this.$router.push('/index/home')
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.indexWrap {
    position: relative;
    width: 100%;
    height: 100%;
}
.indexSection {
    width: 100%;
    overflow: hidden;
    height: calc(100% - 0.5rem);
    box-sizing: border-box;
}
.indexBottom {
    width: 100%;
    min-height: .5rem;
    // position: absolute;
    // left: 0;
    // bottom: 0;
    // z-index: 1;
    padding: 0 .48rem;
    box-sizing: border-box;
    .imgStyle {
        width: .27rem;
    }
    .navIcon {
        font-size: .27rem;
    }
    .navText {
        color: #A7B1D9;
    }
}
</style>